export default function isFunction(f) {
  return typeof f === 'function';
}